import React from 'react';
import { FormattedMessage } from 'react-intl';

const UpdatedSuccessNotificationContent = () => {
    return (
        <FormattedMessage
        id="ids_updateSuccessful"/>
    );
}

export default UpdatedSuccessNotificationContent;